// © Microsoft Corporation. All rights reserved.

/**
 * Local storage key to save prerendered page reload telemetry data
 */
export const expPersistentDataChangeTrackerKey = "epdu";

/**
 * Local storage key to save prerendered page reload telemetry data
 */
export const prerenderedPageReload = "ppreload";

/**
 * Local storage key to track of the page's age (used for telemetry)
 */
export const prerenderedPageAge = "ppage";

/**
 * The key for storing "timeTakenFromVisibleToReload" value in local storage.
 * This value will be used to calculate the totalTimeTaken between when the current page became visible
 * and next page(same page reloaded by prerender code)'s TTAFMax event.
 */
export const timeTakenFromVisibleToReloadKey = "timeTakenFromVisibleToReload";

/**
 * Visibility change event
 */
export const visibilityChangeEventName = "visibilitychange";

/**
 * Force reload flag name
 */
export const forceReloadFlagName = "fpr";

/**
 * Time To Page Reveal when page's primary content is already rendered.
 * This is for when the page was revealed after the page had finished loading in the background
 */
export const timeToPageRevealMarker = "TTPR";

/**
 * Time To Functional SearchBox
 */
export const timeToFunctionalSearchBoxMarker = "TTF.SearchBox";

/**
 * Time To Visually Ready Marker
 */
export const timeToVisuallyReadyMarker = "TTVR";

/**
 * Time To Visually Ready Marker SearchBox
 */
export const timeToVisuallyReadySearchBoxMarker = "TTVR.SearchBox";

/**
 * Time To Visually Ready Marker when the page was loaded in the background
 */
export const ttvrBackgroundExecution = "TTVR.BackgroundExecution";

/**
 * PageTiming entry added when the page is background preloaded
 */
export const backgroundPreloadKey = "backgroundpreload";

/**
 * PageTiming entry added when the page is prerendered
 */
export const prerenderKey = "prerender";

/**
 * Time To Page Visible
 */
export const timeToPageVisible = "TTPV";